import React, { useState, useEffect, useRef } from "react";

import { useDispatch, useSelector, shallowEqual } from "react-redux";

import {
  Table,
  Tooltip,
  Tag,
  Form,
  Input,
  Button,
  Space,
  Modal,
  Descriptions,
  Divider,
  Statistic,
  Col,
  Popconfirm,
  Collapse,
  Select,
  DatePicker,
  TimePicker,
  Checkbox,
  message,
} from "antd";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  UserOutlined,
  VideoCameraOutlined,
  UploadOutlined,
  DeploymentUnitOutlined,
  SearchOutlined,
  EditOutlined,
  PlusOutlined,
  SaveOutlined,
} from "@ant-design/icons";

import "./styles.scss";

import moment from "moment";
import {
  getData,
  editItem,
  addItem,
  deleteItem,
  updateItem,
} from "../../../Redux/actions/crudActions";
import {
  getProductInventory,
  setProductInventory,
} from "../../../Redux/actions/inventoryActions";
import {
  getProductIngredients,
  getProduct,
  setPrice,
} from "../../../Redux/actions/productActions";
import {
  getWeightedExchangeRate,
  calculateWeightedExchangeRate,
} from "../../../Redux/actions/exchangerateActions";

import { errorParser, numberWithCommas } from "../../../utils/helpers";

import CreateForm from "../../Generic/CreateForm";
import ProductInventoryChange from "../ProductInventoryChange";
import AddEditIngredientsModal from "../AddEditIngredientsModal";
import ProductProcess from "../ProductProcess";

const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const { Option } = Select;

const MODAL_BLUEPRINT = [
  {
    title: "Product",
    key: "product",
    type: "options",
    api: "products",
    rules: {
      required: true,
    },
  },
  {
    title: "product_name",
    key: "product_name",
    type: "hidden",
  },
  {
    title: "Quantity",
    key: "quantity",
    type: "number",
    rules: {
      required: true,
    },
  },
];

const Index = ({ currentItem, done }) => {
  const dispatch = useDispatch();
  const { user, locations } = useSelector(
    (state) => ({
      user: state.auth.user,
      locations: state.locations.locations,
    }),
    shallowEqual
  );

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [resetTable, setResetTable] = useState(false);
  const [modalMode, setModalMode] = useState("edit");
  const [currentSelected, setCurrentSelected] = useState(null);

  const [totalPeso, setTotalPeso] = useState(null);
  const [totalRMB, setTotalRMB] = useState(null);
  const [maxProduced, setMaxProduced] = useState(0);

  const [currentWeighted, setCurrentWeighted] = useState(0);

  useEffect(() => {
    if (currentItem) {
      if (currentItem.id) {
        getcurrentrate();
        if (currentWeighted !== 0) {
          retrieveIngredients();
        }
      }
    } else {
      setTotalPeso(0);
      setTotalRMB(0);
    }
  }, [currentItem, currentWeighted]);

  useEffect(() => {
    IngredientPriceChange();
  }, [totalPeso, totalRMB]);

  useEffect(() => {
    if (currentWeighted !== 0) {
      retrieveIngredients();
    }
  }, [currentWeighted]);

  const getcurrentrate = async () => {
    var currentaverage = await dispatch(getWeightedExchangeRate());
    if (currentaverage) {
      setCurrentWeighted(currentaverage.value.toFixed(2));
    }
  };
  const retrieveIngredients = () => {
    dispatch(getProductIngredients(currentItem.id))
      .then((res) => {
        var docs = res.docs;
        var dataArray = [];
        docs.map((item) => {
          var newOrder = {
            key: item.id,
            id: item.id,
            ...item.data(),
          };
          dataArray.push(newOrder);
        });

        if (dataArray.length > 0) {
          createData(dataArray);
        } else {
          done("no ingredients");
          if (currentItem?.cost_peso) {
            setTotalPeso(currentItem.cost_peso);
          } else {
            setTotalPeso("no price");
          }
        }
      })
      .catch((err) => {});
  };

  const createData = async (invn) => {
    var loc = user.branch;
    var madeData = [];
    if (invn) {
      await Promise.all(
        invn.map(async (indx) => {
          var product = await dispatch(getProduct(indx.product));
          if (product) {
            var newstuff = {
              ...indx,
              src: indx,
              sku: product.sku,
              regionalization: product.regionalization,
              cost_peso: product.cost_peso,
              cost_rmb: product.cost_rmb,
              unit: product.unit,
              available_quantity: product[`${loc}_count`]
                ? product[`${loc}_count`]
                : 0,
            };
            if (newstuff.regionalization == "international") {
              newstuff["cost_peso"] =
                parseFloat(newstuff.cost_rmb) * parseFloat(currentWeighted);
            }
            madeData.push(newstuff);
          } else {
            console.log(indx);
            message.error(`${indx.product_name} not found`);
          }
        })
      );

      var total_peso = 0;
      var total_rmb = 0;
      var max = [];

      madeData.map((item) => {
        if (item.regionalization == "international") {
          if (item.cost_rmb) {
            total_peso =
              total_peso +
              parseFloat(item.cost_rmb) *
                parseFloat(currentWeighted) *
                parseFloat(item.quantity);
            total_rmb =
              total_rmb + parseFloat(item.cost_rmb) * parseFloat(item.quantity);
          }
        } else {
          if (item.cost_peso) {
            total_peso =
              total_peso +
              parseFloat(item.cost_peso) * parseFloat(item.quantity);
          }
        }

        var denominate = 0;

        if (item.available_quantity && item.quantity) {
          denominate =
            parseFloat(item.available_quantity) / parseFloat(item.quantity);
        }

        max.push(denominate);
      });

      setTotalPeso(total_peso);
      setTotalRMB(total_rmb);
      if (max.length > 0) {
        var min = Math.min(...max);
        min = Math.max(min, 0);
        setMaxProduced(min);
      } else {
        setMaxProduced(0);
      }

      setData(madeData);
    }
  };

  const columns = [
    {
      title: "Product",
      dataIndex: "product_name",
      key: "product_name",
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
      render: (text, record, index) => {
        return (
          <Tooltip
            title={
              <div className="vertical">
                <div>{`${numberWithCommas(parseFloat(text).toFixed(2))} ${
                  record.unit
                }`}</div>
                {record.second_unit_rate &&
                parseFloat(record.second_unit_rate) > 0 ? (
                  <div>{`${numberWithCommas(
                    (
                      parseFloat(text) * parseFloat(record.second_unit_rate)
                    ).toFixed(2)
                  )} ${record.second_unit}`}</div>
                ) : null}
              </div>
            }
          >
            {numberWithCommas(parseFloat(text).toFixed(2))}
          </Tooltip>
        );
      },
    },
    {
      title: "Available",
      dataIndex: "available_quantity",
      key: "available_quantity",
      render: (text, record, index) => {
        return (
          <Tooltip
            title={
              <div className="vertical">
                <div>{`${numberWithCommas(parseFloat(text).toFixed(2))} ${
                  record.unit
                }`}</div>
                {record.second_unit_rate &&
                parseFloat(record.second_unit_rate) > 0 ? (
                  <div>{`${numberWithCommas(
                    (
                      parseFloat(text) * parseFloat(record.second_unit_rate)
                    ).toFixed(2)
                  )} ${record.second_unit}`}</div>
                ) : null}
              </div>
            }
          >
            {numberWithCommas(parseFloat(text).toFixed(2))}
          </Tooltip>
        );
      },
    },
    {
      title: "Unit",
      dataIndex: "unit",
      key: "unit",
    },
  ];

  const filterColumns = () => {
    var newcols = columns;
    var admincols = [
      {
        title: "Unit Peso Price",
        dataIndex: "cost_peso",
        key: "cost_peso",
        render: (text, record, index) => {
          return numberWithCommas(parseFloat(text).toFixed(2));
        },
      },
      {
        title: "Price Peso",
        render: (text, record, index) => {
          var price_product =
            parseFloat(record.cost_peso) * parseFloat(record.quantity);
          return numberWithCommas(parseFloat(price_product).toFixed(3));
        },
      },
      {
        title: "Unit RMB Price",
        dataIndex: "cost_rmb",
        key: "cost_rmb",
        render: (text, record, index) => {
          return numberWithCommas(parseFloat(text).toFixed(2));
        },
      },
      {
        title: "Price RMB",
        render: (text, record, index) => {
          var price_product =
            parseFloat(record.cost_rmb) * parseFloat(record.quantity);
          return numberWithCommas(parseFloat(price_product).toFixed(3));
        },
      },
    ];
    if (user.role == "admin") {
      newcols = newcols.concat(admincols);
    }

    return newcols;
  };

  const IngredientPriceChange = () => {
    if (totalPeso != undefined && totalRMB != undefined) {
      var usePeso = 0;
      var useRMB = 0;

      if (totalPeso) {
        usePeso = parseFloat(totalPeso);
      }
      if (totalRMB) {
        useRMB = totalRMB;
      }

      if (
        currentItem.cost_peso !== usePeso.toFixed(2) ||
        currentItem.cost_rmb !== useRMB.toFixed(2)
      ) {
        savePriceChanges();
        // console.log(currentItem.cost_peso,totalPeso.toFixed(2), currentItem.cost_rmb,totalRMB.toFixed(2) )
      } else {
        done("same");
      }
    }
  };

  const savePriceChanges = () => {
    setLoading(true);

    var usePeso = 0;
    var useRMB = 0;
    if (totalPeso) {
      usePeso = parseFloat(totalPeso);
    }
    if (totalRMB) {
      useRMB = totalRMB;
    }

    var formbase = {
      cost_peso: usePeso.toFixed(2),
      cost_rmb: useRMB.toFixed(2),
    };

    var newform = {
      ...formbase,
    };
    var newPrice = {
      ...formbase,
      reason: "ingredients price change",
      created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
    };

    dispatch(updateItem(newform, "products", currentItem.id))
      .then((res) => {
        dispatch(setPrice(newPrice, currentItem.id))
          .then((res2) => {
            message.success(`${currentItem.name} price changed`);

            retrieveIngredients();
            setLoading(false);
            done(usePeso);
          })
          .catch((err2) => {
            console.log("err2", err2);
            var formattedErr = errorParser(err2.response);
            if (
              typeof formattedErr == "object" ||
              typeof formattedErr == "array"
            ) {
              formattedErr.map((er) => {
                message.error(er);
              });
            } else {
              message.error(formattedErr);
            }
            retrieveIngredients();

            setLoading(false);
            done("error");
          });
      })
      .catch((err) => {
        var formattedErr = errorParser(err.response);
        if (typeof formattedErr == "object" || typeof formattedErr == "array") {
          formattedErr.map((er) => {
            message.error(er);
          });
        } else {
          message.error(formattedErr);
        }
        retrieveIngredients();

        setLoading(false);
        done("error");
      });
  };

  if (totalPeso) {
    if (totalPeso < currentItem.cost_peso) {
      return (
        <div className="green">
          {`₱${numberWithCommas(parseFloat(totalPeso).toFixed(2))}`}
        </div>
      );
    } else if (totalPeso > currentItem.cost_peso) {
      return (
        <div className="red">
          {`₱${numberWithCommas(parseFloat(totalPeso).toFixed(2))}`}
        </div>
      );
    } else {
      return `₱${numberWithCommas(parseFloat(totalPeso).toFixed(2))}`;
    }
  } else if (totalPeso == "no price") {
    return (
      <div className="red">
        <Tag color="red">no price</Tag>
      </div>
    );
  } else {
    return <Tag color="green">calculating</Tag>;
  }
};

export default Index;
